import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async"; 
import "./index.css";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

// ✅ ENV CHECK
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

if (!posthogKey || !posthogHost) {
  console.error("❌ PostHog env vars missing");
}

posthog.init(posthogKey, {
  api_host: posthogHost,
  autocapture: true,
  capture_pageview: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
      <HelmetProvider>
    <PostHogProvider client={posthog}> 
      <AuthProvider>
        <App />
        <Toaster position="top-right" reverseOrder={false} />
      </AuthProvider>
    </PostHogProvider>
    </HelmetProvider>
  </React.StrictMode>
);
